import React from "react";

/**
 * Shared title block for "Overall KPIs" sections so voice Summary / Inbound / Outbound
 * and digital channels read as one family with the GREAT score cards above.
 */
export default function GreatOverallKpiHeader({ scopeLabel, periodLabel, departmentFilter, extra }) {
  const dept = departmentFilter ? departmentFilter : "All Departments";
  return (
    <div className="mb-4 border-b border-gray-200 pb-4 dark:border-navy-700">
      <h4 className="text-xl font-bold text-navy-700 dark:text-white font-dm">Overall KPIs</h4>
      <p className="mt-1 text-xs text-navy-700 dark:text-gray-300">
        {scopeLabel}
        {periodLabel ? ` · ${periodLabel}` : ""}
        {" · "}
        Department: {dept}
        {extra ? ` · ${extra}` : ""}
      </p>
      <p className="mt-1 text-xs text-navy-700 dark:text-gray-300">
        Uses the same filters as the GREAT Score Overview above unless noted.
      </p>
    </div>
  );
}
